export const MAINTENANCE_PATH = '/maintenance/';

/**
 * @returns {boolean}
 */
export function isMaintenanceModeWebEnabled() {
  return process.env.MAINTENANCE_MODE_WEB === 'true';
}

/**
 * @param {string} path
 * @returns {boolean}
 */
export function isMaintenanceRoute(path) {
  if (!path || typeof path !== 'string') {
    return false;
  }
  const normalized = path.endsWith('/') ? path : `${path}/`;
  return normalized === MAINTENANCE_PATH;
}

/**
 * @param {string} path
 * @returns {boolean}
 */
export function shouldRedirectToMaintenance(path) {
  if (!isMaintenanceModeWebEnabled()) {
    return false;
  }
  return !isMaintenanceRoute(path);
}
